import { useRouter } from "vue-router";

export function useOrderToggle() {
  const router = useRouter();


  const goToOrderCreate = (currentLocation, selectedLocation) => {
    const locationId = currentLocation && currentLocation.id != 0 ? currentLocation.id : selectedLocation?.id;

    localStorage.removeItem("isSpeq");
    localStorage.removeItem("is_selected_location_speq");

    router.push({name: 'OrderCreate', query: {location_id: locationId}})
  };

  const goToSpeqOrderCreate = (currentLocation, selectedLocation) => {
    const locationId = currentLocation && currentLocation.id != 0 ? currentLocation.id : selectedLocation?.id;

    localStorage.setItem("isSpeq", 'true');

    router.push({name: 'speqOrderCreate', query: {location_id: locationId}})
  };

  return {
    goToOrderCreate,
    goToSpeqOrderCreate,
  };
}